(() => {
  'use strict';
  let stopTracker = null;
  let loading = false;
  let attempts = 0;
  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
  function marketingAllowed() {
    try { return privacy()?.marketingAllowed() === true; } catch (_) { return false; }
  }
  function clearAffiliateData() {
    const names = ['bgvisitor_id', 'bgaffilite_id', 'bglast_click', 'bgexpire_time', 'bgclick_id', 'bgcart'];
    const parts = location.hostname.split('.');
    const domains = ['', location.hostname];
    for (let i = 1; i < parts.length - 1; i++) domains.push(parts.slice(i).join('.'));
    for (const name of names) for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ''}`;
    }
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (/^bg_flag_(app|pixel)_/.test(key)) localStorage.removeItem(key);
      }
    } catch (_) {}
    document.querySelectorAll('input[name="properties[_bg_aff]"], input[name="properties[_bg_click_id]"]').forEach(input => input.remove());
  }
  function syncConsent() {
    if (marketingAllowed()) {
      if (!stopTracker) stopTracker = startBixGrow();
    } else {
      if (stopTracker) stopTracker();
      stopTracker = null;
      clearAffiliateData();
    }
  }
  function initPrivacy() {
    if (privacy()) { syncConsent(); return; }
    if (loading) return;
    if (window.Shopify?.loadFeatures) {
      loading = true;
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        loading = false;
        if (!error && privacy()) syncConsent();
        else if (++attempts < 20) setTimeout(initPrivacy, 500);
      });
    } else if (++attempts < 20) setTimeout(initPrivacy, 500);
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('pageshow', initPrivacy);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) initPrivacy(); });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bb-cookie-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-bb-cookie-status]');
    if (status) status.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      initPrivacy();
      for (let i = 0; i < 40 && !window.privacyBanner?.showPreferences; i++) {
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      if (!window.privacyBanner?.showPreferences) throw new Error('Unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (status) status.textContent = status.dataset.error;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  initPrivacy();
function startBixGrow() {
  let active = true;
  const controller = new AbortController();
  const allowed = () => active && marketingAllowed();
const BG_TRACKER_BASE_URL = "https://track.bixgrow.com/api";


function bgGetExtraReferralIdentifiers() {
  try {
    const raw =
      typeof bgReferralIdentifiersRaw !== "undefined"
        ? bgReferralIdentifiersRaw
        : "[]";
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

let bgRefCode = bgGetParameterByName("bg_ref");
if (!bgRefCode) {
  for (const referralIdentifier of bgGetExtraReferralIdentifiers()) {
    bgRefCode = bgGetParameterByName(referralIdentifier);
    if (bgRefCode) break;
  }
}

let bgVisitorId = bgGetCookie("bgvisitor_id");
let affiliateId = bgGetCookie("bgaffilite_id");
let lastClick = bgGetCookie("bglast_click");

(function () {
  const PROPERTY_KEY = "_bg_aff";
  const PROPERTY_VALUE = bgRefCode || affiliateId;

  function injectHiddenInputs(form) {
    if (!form || !allowed()) return;

    const existingAffInput = form.querySelector(`input[name="properties[${PROPERTY_KEY}]"]`);

    if (PROPERTY_VALUE) {

      if (!existingAffInput) {
        const hiddenAff = document.createElement("input");
        hiddenAff.type = "hidden";
        hiddenAff.name = `properties[${PROPERTY_KEY}]`;
        hiddenAff.value = PROPERTY_VALUE;
        form.appendChild(hiddenAff);
      } else {
        existingAffInput.value = PROPERTY_VALUE;
      }
    } else {
      if (existingAffInput) {
        existingAffInput.remove();
      }
    }

    const clickId = bgGetCookie("bgclick_id");
    const existingClickInput = form.querySelector('input[name="properties[_bg_click_id]"]');

    if (clickId) {
      if (!existingClickInput) {
        const hiddenClick = document.createElement("input");
        hiddenClick.type = "hidden";
        hiddenClick.name = "properties[_bg_click_id]";
        hiddenClick.value = clickId;
        form.appendChild(hiddenClick);
      } else {
        existingClickInput.value = clickId;
      }
    } else {
      if (existingClickInput) {
        existingClickInput.remove();
      }
    }
  }

  function attachToForms() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach((form) => {
      injectHiddenInputs(form);

      const buttons = form.querySelectorAll('button, input[type="submit"]');
      buttons.forEach((btn) => {
        
        btn.addEventListener("mousedown", () => injectHiddenInputs(form), {signal: controller.signal});
        btn.addEventListener("touchstart", () => injectHiddenInputs(form), {signal: controller.signal});
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachToForms, {once: true, signal: controller.signal});
  } else { attachToForms(); }
})();

applyAutomaticDiscount(bgRefCode, affiliateId);
if (bgRefCode) {
  if (bgVisitorId === "") {
    let payload = {
      aff_id: bgRefCode,
      event_type: "click",
      referral_site: document.referrer,
      destination_url: window.location.href,
    };
    bgPostEventOnce("click", payload);
  } else {
    if (affiliateId != bgRefCode) {
      let payload = {
        aff_id: bgRefCode,
        visitor_id: bgVisitorId,
        event_type: "click",
        referral_site: document.referrer,
        destination_url: window.location.href,
      };
      bgPostEventOnce("click", payload);
    } else {
      if (new Date().getTime() - lastClick > 60 * 1000) {
        let payload = {
          aff_id: bgRefCode,
          visitor_id: bgVisitorId,
          event_type: "click",
          referral_site: document.referrer,
          destination_url: window.location.href,
        };
        bgPostEventOnce("click", payload);
      }
    }
  }
}

var bgSetInterval = setInterval(function () {
  if (!allowed()) return;
  let currentShopifyCart = bgGetCookie("cart");
  if (
    bgGetCookie("bgvisitor_id") !== "" &&
    currentShopifyCart !== "" &&
    bgGetCookie("bgcart") != bgGetCookie("cart")
  ) {
    bgSetCookie("bgcart", currentShopifyCart, 100);
    clearInterval(bgSetInterval);
    let payload = {
      aff_id: bgGetCookie("bgaffilite_id"),
      visitor_id: bgGetCookie("bgvisitor_id"),
      event_type: "add_to_cart",
      cart_token: sanitizeCartCookie(currentShopifyCart),
      click_id: bgGetCookie("bgclick_id"),
    };
    bgPostEventOnce("add_to_cart", payload);
  }
}, 1000);

function sanitizeCartCookie(cartValue) {
  if (!cartValue) return cartValue;
  return cartValue.split("?")[0];
}

async function bgPostEvent(data) {
  if (!allowed()) return;
  const apiURl = `${BG_TRACKER_BASE_URL}/bg_trackv2`;
  try {
    const response = await fetch(apiURl, {
      method: "POST",
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
    }

    const responseData = await response.json();
    if (!allowed()) return;
    if (
      responseData.event_type == "click" &&
      typeof responseData.visitor_id !== "undefined"
    ) {
      bgSetCookieByUnixTime(
        "bgvisitor_id",
        responseData.visitor_id,
        responseData.expire_at
      );
      bgSetCookieByUnixTime(
        "bgaffilite_id",
        data.aff_id,
        responseData.expire_at
      );
      bgSetCookieByUnixTime(
        "bglast_click",
        new Date().getTime(),
        responseData.expire_at
      );
      bgSetCookieByUnixTime(
        "bgexpire_time",
        responseData.expire_at,
        responseData.expire_at
      );
      bgSetCookieByUnixTime(
        "bgclick_id",
        responseData.click_id,
        responseData.expire_at
      );
    } else if (responseData.event_type == "add_to_cart") {
      clearInterval(bgSetInterval);
    }
  } catch (error) {
    console.error("Bixgrow - error:", error);
  }
}

function bgSetCookieByUnixTime(cname, cvalue, unixTime) {
  if (!allowed()) return;
  var d = new Date(unixTime * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

console.log(
  `%c ► Bixgrow:App embed tracker`,
  "background-color: #f90; color: #fff; padding: 5px;"
);

async function applyAutomaticDiscount(bgRefCode, affiliateIdFromCookies) {
  if (!allowed()) return;
  let affiliateId = bgRefCode || affiliateIdFromCookies;
  if (!affiliateId) {
    return 1;
  }
  const apiURl = `${BG_TRACKER_BASE_URL}/automatic-coupon-customer?shop=${Shopify.shop}&affiliateId=${affiliateId}`;
  try {
    const response = await fetch(apiURl, {
      method: "GET",
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (!response.ok) {
    }

    const responseData = await response.json().catch(() => null);
    if (!allowed() || !responseData) {
      return;
    }
    if (responseData?.couponCode) {
      autoAppliedCoupon(responseData?.couponCode);
    }
  } catch (error) {
    console.error("Bixgrow - error:", error);
  }
}

async function autoAppliedCoupon(discountCode) {
  if (!allowed()) return;
  discountCode = encodeURIComponent(discountCode);
  try {
    const url = `${window.location.origin}/discount/${discountCode}`;
    await bgUseFetch(url, "GET");
  } catch (error) {
  }
}

async function bgUseFetch(
  url,
  method = "GET",
  params = null,
  headers = { "Content-Type": "application/json" }
) {
  if (!allowed()) return;
  try {
    const options = {
      signal: controller.signal,
      method: method,
      headers: {
        ...headers,
      },
    };
    if (params) {
      if (method == "GET") {
        const queryString = new URLSearchParams(params).toString();
        url += "?" + queryString;
      } else {
        options.body = JSON.stringify(params);
      }
    }
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const responseData = await response.json().catch(() => null);
    if (responseData) {
      return responseData;
    }
  } catch (error) {
    throw error;
  }
}

function bgGetCookie(cname) {
  if (!allowed()) return "";
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function bgSetCookie(cname, cvalue, exdays) {
  if (!allowed()) return;
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function bgGetParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

async function bgPostEventOnce(eventType, payload) {
  if (!allowed()) return;
  const appKey = `bg_flag_app_${eventType}`;
  const pixelKey = `bg_flag_pixel_${eventType}`;

  if (localStorage.getItem(pixelKey) === "called") {
    localStorage.removeItem(pixelKey);
    return;
  }

  localStorage.setItem(appKey, "called");
  return bgPostEvent(payload);
}

  return () => { active = false; controller.abort(); clearInterval(bgSetInterval); };
}

})();
